var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 89,
    viewBox: "0 0 90 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 89,
    rx: 44.5,
    fill: "#0094FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.9334 48.7879L44.9211 48.7879C44.489 48.7895 44.0657 48.668 43.7028 48.4382L43.6079 48.3786L43.5429 48.3391L42.4381 47.4427L16.0681 26.1243C16.0965 26.0862 16.1336 26.0552 16.1764 26.0336C16.2192 26.012 16.2665 26.0005 16.3146 26L73.6988 26C73.7677 26.0004 73.8343 26.0239 73.8875 26.0667L46.2982 48.3462C45.9079 48.6413 45.4264 48.7971 44.9334 48.7879ZM74 29.0208L74 60.6214L54.2362 44.9808L74 29.0208ZM35.7453 45.0899L16.0021 60.6336L16.0021 29.1218L35.7453 45.0899ZM42.0224 50.1644C42.8492 50.7993 43.8691 51.1449 44.9197 51.1458C45.9702 51.1467 46.9908 50.803 47.8187 50.1694L52.3453 46.5119L74 63.6432L74 63.6968C74 63.7772 73.9674 63.8543 73.9094 63.9112C73.8514 63.9681 73.7726 64 73.6905 64L16.3095 64C16.2274 64 16.1486 63.9681 16.0906 63.9112C16.0326 63.8543 16 63.7772 16 63.6968L16 63.6473L37.6361 46.616L42.0224 50.1644Z",
    fill: "#FDFDFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.de213812b1011cb5c3f4c4f1a17cb945.svg";
export { ForwardRef as ReactComponent };